
import DriverLayout from '../../layouts/DriverLayout'
import {
  Box, OrderedList, ListItem,  Heading,
} from "@chakra-ui/react";

const DriverTips = () => {
  return (
    <DriverLayout>
      <Box maxW="1000px" mx="auto" px={4}>
        <Box maxW="900px" mx="auto" mt={2}>
          <Box
            bgGradient="linear(to-r, #3182ce, #63b3ed)"
            color="white"
            py={3}
            px={6}
            borderTopRadius="xl"
            boxShadow="md"
          >
            <Heading size="sm">Tips</Heading>
          </Box>
          <Box

            bg="white"
            p={{ base: 4, md: 6 }}
            borderWidth={1}
            borderColor="gray.200"
            borderBottomRadius="xl"
            boxShadow="xl"
          >
            <OrderedList spacing={3} fontSize="sm" color="gray.700">
              <ListItem>Keep vehicle well maintained and clean with insurance updated</ListItem>
              <ListItem>Dress decently and talk softly</ListItem>
              <ListItem>Look at passenger details before confirming ride</ListItem>
              <ListItem>Gently move to left for passenger pickup</ListItem>
              <ListItem>Check passenger details with OTP before taking passenger into the car</ListItem>
              <ListItem>Use your instincts for deciding on giving ride to passenger</ListItem>
              <ListItem>Preferably take one passenger from one location to avoid group risk</ListItem>
              <ListItem>Ensure pickup and drop is done by parking on the side</ListItem>
              <ListItem>Use emergency button - whenever required</ListItem>
              <ListItem>You can Cancel Ride anytime</ListItem>
              <ListItem>Ensure emergency numbers are correct</ListItem>
              <ListItem>Stick to main roads</ListItem>
              <ListItem>Do not talk on the cell when driving</ListItem>
              <ListItem>Preferably use AAJAA during normal hours - 8am to 8pm</ListItem>
            </OrderedList>
          </Box>
        </Box>
      </Box>
    </DriverLayout>
  )
}

export default DriverTips
